import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Steps = ({ children, values, dataCy }) => (React.createElement("ul", { className: midas.step, "data-cy": dataCy },
    values.map((item) => (React.createElement("li", { key: item.step, className: classNames(midas.stepItem, item.active && midas.active) },
        React.createElement("a", { href: item.href, "data-tooltip": item.tooltip || null },
            React.createElement("div", { style: { paddingTop: '.8rem' } }, item.icon && React.createElement("i", { className: midas[item.icon] })),
            React.createElement("span", { style: { marginLeft: '-100%', marginRight: '-100%' } }, item.label))))),
    children));
export default Steps;
